import axios from "@/plugins/axios.js"
import api from "@/api.js"
export default new class AnalyticService{
	constructor(){
		this.list = [];
	}
	getFaces(){
		return this.list;
	}
	async getList(pg=1){
		try{
			if (api) {				
				const uri = `${api.url}/api/v1/analytic/?page=${pg}`;					
				const data = await axios.get(uri);							
				return data;
			}
		}catch(er){
			console.warn("Error get analytic ", er)
			return er;
		}
		return null;
	}
	async getListFor(pg=1){		
		try{
			let isloadingReq = true; 
			while(isloadingReq){
				const res =  await this.getList(pg);
				if (res && res.data && res.data.rows.length > 0) {						
					this.list 		= this.list.concat(res.data.rows);// temp_list;					
				}			
				// console.log("valid list ", parseInt(res.data.pages) > pg, parseInt(res.data.pages) , " > ", pg)		
				if (parseInt(res.data.pages) > pg) {
					pg++;				
				}else{
					isloadingReq=false
					// console.log("return list ", this.list)
					return this.list;
				}
			}
			
		}catch(er){
			console.warn("Error get analytic For ", er)
			return er;
		}
		
	}
}